import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';

import { InsertLinkEvent } from '../../model/event.model';
import { linkValidator } from '../../components/shared/forms-validation/link-validator';
import { WkInsertWebEmailLinkService } from '../../services/wk-insert-web-email-link.service';
import { WKInsertLinkComponent } from '../wk-insert-link/wk-insert-link.component';

@Component({
  selector: 'wk-web-email-address-link.component',
  templateUrl: './wk-web-email-address-link.component.html',
  styleUrls: ['./wk-web-email-address-link.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class WKWebEmailAddressLinkComponent implements OnInit {
  insertLinkEvent: InsertLinkEvent;
  dialogRef: MatDialogRef<WKInsertLinkComponent>;

  linkText = '';
  linkAddress = '';
  isPreviousLink = false;

  changedTextImplicitly = false;

  closeDialogSubscription: Subscription;

  form: UntypedFormGroup;

  constructor(
    private readonly formBuilder: UntypedFormBuilder,
    private readonly wkInsertWebEmailLinkService: WkInsertWebEmailLinkService
  ) {}

  ngOnInit() {
    if (this.insertLinkEvent.linkAttributes) {
      this.linkText = this.insertLinkEvent.linkAttributes.linkText;
      this.linkAddress = this.insertLinkEvent.linkAttributes.linkAddress;
      this.changedTextImplicitly = true;
      this.isPreviousLink = true;
    } else if (this.insertLinkEvent.editor) {
      const selection = this.insertLinkEvent.editor.model.document.selection;
      const ranges = selection.getRanges();

      this.checkRanges(ranges);
    }

    this.form = this.formBuilder.group({
      linkText: [this.linkText, [Validators.required]],
      linkAddress: [
        this.linkAddress,
        [Validators.required, linkValidator('linkAddress')],
      ],
    });

    this.form.get('linkAddress').valueChanges.subscribe((change) => {
      if (!this.changedTextImplicitly) {
        this.form.patchValue(
          {
            linkText: change,
          },
          { emitEvent: false }
        );
      }
    });

    this.form.get('linkText').valueChanges.subscribe(() => {
      this.changedTextImplicitly = true;
    });

    this.listenToDialogCloseAction();
  }

  private listenToDialogCloseAction() {
    this.closeDialogSubscription = this.wkInsertWebEmailLinkService
      .getCloseModalDialog()
      .subscribe((value) => {
        if (value) {
          this.wkInsertWebEmailLinkService.setCloseModalDialog(false);
          this.dialogRef.close();
        }
      });
  }

  private checkRanges(ranges: any) {
    for (const range of ranges) {
      for (const item of range.getItems()) {
        if (typeof item.data === 'string' && item.data.length) {
          this.changedTextImplicitly = true;
          this.linkText += item.data;
        }
      }
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
    this.insertLinkEvent.editor?.focus();
  }

  ngOnDestroy() {
    if (this.closeDialogSubscription) {
      this.closeDialogSubscription.unsubscribe();
    }
  }

  insertLink() {
    if (this.form?.valid) {
      const selectedContent = this.insertLinkEvent.editor.data.stringify(
        this.insertLinkEvent.editor.model.getSelectedContent(
          this.insertLinkEvent.editor.model.document.selection
        )
      );
      this.wkInsertWebEmailLinkService.setLinkDetails({
        linkText: this.form.get('linkText').value,
        linkAddress: this.form.get('linkAddress').value,
        linkElement: this.insertLinkEvent?.linkAttributes?.linkElement,
        textSelected: selectedContent !== '',
      });
      this.closeDialog();
    }
  }
}
